import { render, staticRenderFns } from "./UserDownloadRecordList.vue?vue&type=template&id=5dd8e96f&scoped=true"
import script from "./UserDownloadRecordList.vue?vue&type=script&lang=js"
export * from "./UserDownloadRecordList.vue?vue&type=script&lang=js"
import style0 from "./UserDownloadRecordList.vue?vue&type=style&index=0&id=5dd8e96f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8e96f",
  null
  
)

export default component.exports